import analytics from '../../../../modules/analytics';

import { ClientBookingSurveyQuestionType } from './QuestionTypes';

export enum ClientBookingSurveyTypes {
  Com806 = 'COM_806',
  Res194 = 'RES_194',
}

export const COM_806_TEST_NAME = 'client_feedback_ncd_attribution_com_806_20220519';
export const COM_806_TEST_PERCENT = 0.5;
export const COM_806_TEST_QUESTIONS = [
  {
    id: 0,
    text:
      'How did your experience with StyleSeat impact your'
      + ' decision to book with this stylist?',
    answers: [
      {
        id: 0,
        text: 1,
      },
      {
        id: 1,
        text: 2,
      },
      {
        id: 2,
        text: 3,
      },
      {
        id: 3,
        text: 4,
      },
      {
        id: 4,
        text: 5,
      },
    ],
    type: ClientBookingSurveyQuestionType.Numeric,
    leftHelperText: 'Not at all',
    rightHelperText: 'A lot',
  },
];

export const RES_194_FLAG = 'client_feedback_ncd_attribution_res_194_20230309';
export const RES_194_SURVEY_QUESTIONS = (providerName: string) => [
  {
    id: 0,
    text: `Have you ever had an appointment with ${providerName} before?`,
    type: ClientBookingSurveyQuestionType.BinaryChoice,
    answers: [
      {
        id: 0,
        text: 'Yes',
        shouldEndSurvey: true,
      },
      {
        id: 1,
        text: 'No',
      },
    ],
    handleTrack: (answerText: string, params: {}) => {
      const results = {
        firstAnswer: answerText,
        ...params,
      };
      analytics.track('client_booking_survey_res_194_question_1_submitted', results);
    },
  },
  {
    id: 1,
    text: 'How did you find this pro?',
    type: ClientBookingSurveyQuestionType.MultipleChoice,
    showSubmitButton: true,
    showUserFillInOption: true,
    answers: [
      {
        id: 0,
        text: 'Referral From a Friend',
      },
      {
        id: 1,
        text: 'Google Search',
      },
      {
        id: 2,
        text: 'StyleSeat',
      },
      {
        id: 3,
        text: 'Social Media',
      },
    ],
    userFillInAnswer: {
      id: 4,
      text: 'Other',
    },
    handleTrack: (answerText: string, params: {}) => {
      const results = {
        secondAnswer: answerText,
        ...params,
      };
      analytics.track('client_booking_survey_res_194_question_2_submitted', results);
    },
  },
];
